import React, { useState, ChangeEvent, useEffect } from "react";
import { PlusIcon } from "lucide-react";
import { RiDeleteBinLine } from "react-icons/ri";

interface Characteristic {
  id?: number;
  productId?: number;
  name: string;
  value: string;
}

interface RemovedCharacteristic {
  id: number;
}

interface CharacteristicsFormProps {
  characteristics: Characteristic[];
  setCharacteristics: React.Dispatch<React.SetStateAction<Characteristic[]>>;
  removedCharacteristics: RemovedCharacteristic[];
  setRemovedCharacteristics: React.Dispatch<
    React.SetStateAction<RemovedCharacteristic[]>
  >;
  setShowAlertOnRouteChange: React.Dispatch<React.SetStateAction<boolean>>;
}

const CharacteristicsForm: React.FC<CharacteristicsFormProps> = ({
  characteristics,
  setCharacteristics,
  removedCharacteristics,
  setRemovedCharacteristics,
  setShowAlertOnRouteChange,
}) => {
  const handleChange = (
    index: number,
    field: keyof Characteristic,
    value: string
  ) => {
    const updatedCharacteristics = [...characteristics];
    const currentCharacteristic = updatedCharacteristics[index];

    if (currentCharacteristic[field] !== value) {
      updatedCharacteristics[index] = {
        ...currentCharacteristic,
        [field]: value,
      };
      setShowAlertOnRouteChange(true);
      setCharacteristics(updatedCharacteristics);
    } else {
      setShowAlertOnRouteChange(false);
    }
  };

  const handleAddRow = () => {
    setShowAlertOnRouteChange(true);
    setCharacteristics([...characteristics, { name: "", value: "" }]);
  };

  const handleRemoveRow = (index: number) => {
    setShowAlertOnRouteChange(true);
    const characteristicToRemove = characteristics[index];

    if (characteristicToRemove.id !== undefined) {
      setRemovedCharacteristics([
        ...removedCharacteristics,
        { id: characteristicToRemove.id },
      ]);
    }

    setCharacteristics(characteristics.filter((_, i) => i !== index));
  };

  return (
    <div className="w-full mx-auto">
      <div className="absolute top-4 right-2">
        <button
          type="button"
          onClick={handleAddRow}
          className="w-full p-1 rounded bg-customGreenColor text-white"
        >
          <PlusIcon className="w-5 h-5" />
        </button>
      </div>
      {characteristics.map((char, index) => (
        <div key={index} className="flex items-center space-x-4 mb-2 w-full">
          <div className="flex items-center gap-2 flex-wrap w-full">
            <input
              type="text"
              placeholder="Name"
              value={char.name}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                handleChange(index, "name", e.target.value)
              }
              className="mt-1 flex-1 w-full border border-gray-300 rounded-lg bg-grayBackgroundColor focus:outline-customGreenColor px-3 py-2"
            />
            <input
              type="text"
              placeholder="Enter details"
              value={char.value}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                handleChange(index, "value", e.target.value)
              }
              className="mt-1 flex-1 w-full border border-gray-300 rounded-lg bg-grayBackgroundColor focus:outline-customGreenColor px-3 py-2"
            />
          </div>
          <button
            type="button"
            onClick={() => handleRemoveRow(index)}
            className=""
          >
            <RiDeleteBinLine className="text-red-600 box-border" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default CharacteristicsForm;
